"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STYLES = void 0;
const custom = (val) => `${val}px`;
exports.STYLES = {
    colors: {
        vitas: {
            /**
             * Vita Learning primary colour
             */
            primary: "#00A6FF",
            /**
             * Vita Learning secondary colour
             */
            secondary: "#0091FF",
            /**
             * Vita Learning complementary colour
             */
            complementary: "#FFD900",
        },
        /**
         * Colors for 'light' mode
         */
        lights: {
            backgrounds: {
                blanks: {
                    normal: "#FFF",
                    interaction: "#F9F9F9",
                },
                dangers: {
                    normal: "#D9534F",
                    interaction: "#FF0000"
                },
                successes: {
                    normal: "#5CB85C"
                },
                cancels: {
                    normal: "#78828A",
                    interaction: "#6C757D",
                },
                /**
                 * Color for info states
                 */
                infos: {
                    normal: "#5BC0DE",
                    interaction: "#5BC0DE",
                },
                /**
                 * Colour for warning states
                 */
                warnings: {
                    normal: "#F0AD4E",
                    interaction: "#F0AD4E",
                },
                /**
                 *
                 */
                tooltip: "#2B2B2B",
                /**
                 * Background colour of pages
                 */
                pages: {
                    light: "#FAFBFE",
                    medium: "#F6F8FE",
                    dark: "#EFF2FD"
                },
            },
            /**
             * Colours for icons
             */
            icons: {
                normal: "#91A9C7",
                interaction: "#809CBE",
            },
            /**
             * Colours for borders
             *
             */
            borders: {
                /**
                 * Used for elements that hold other elements and are not directly interacted with.
                 *
                 * E.g. containers, columns, rows, etc.
                 */
                light: "#EFEFEF",
                /**
                 * Used for elements that can be interacted with.
                 *
                 * E.g. buttons, dropdowns, inputs, etc.
                 */
                medium: "#CCC",
                /**
                 * Used for interactive elements that are interacted with.
                 *
                 * E.g. pressed buttons, pressed dropdowns, focused inputs, etc.
                 */
                dark: "#B3B3B3",
            },
            texts: {
                heading: "#444",
                normal: "#444",
                subheading: "#434343",
                subtle: "#666",
                striked: "#B3B3B3",
            },
        },
    },
    /**
     * Colors for 'dark' mode
     */
    darks: {},
    providers: {
        googles: {
            normal: "#4285F4",
            interaction: "#1669F2"
        },
        facebooks: "#4267B2"
    },
    fonts: {
        sizes: {
            small: "0.75rem",
            text: "1rem",
            subheading: "1.167rem",
            heading: "1.5rem",
            title: "2rem",
            custom(val) {
                return `${val}px`;
            }
        },
        weights: {
            light: 200,
            normal: 400,
            medium: 500,
            bold: 700,
            thick: 900,
            custom(val) {
                return val;
            }
        },
        family: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,	'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'"
    },
    spacings: {
        xxs: "0.125rem",
        xs: "0.25rem",
        sm: "0.5rem",
        md: "0.75rem",
        lg: "1rem",
        xl: "1.5rem",
        xxl: "2rem",
        "3xl": "4rem",
        "4xl": "8rem",
        "5xl": "16rem",
        custom
    },
    breakpoints: {
        mobiles: {
            landscape: "min-width: 576px"
        },
        tablets: {
            portrait: "min-width: 768px",
            landscape: "min-width: 992px"
        },
        laptops: {
            small: "min-width: 1200px",
            large: "min-width: 1440px",
        },
        desktop: "min-width: 2100px",
        custom(breakpoint) {
            return `min-width: ${breakpoint}px`;
        }
    },
    shadows: {
        light: "rgba(0, 0, 0, 8%)",
        medium: "rgba(0, 0, 0, 16%)",
        dark: "rgba(0, 0, 0, 32%)",
        custom(r, g, b, a) {
            if (!a)
                return `rgb(${r} ,${g}, ${b})`;
            return `rgba(${r}, ${g}, ${b}, ${a}%)`;
        }
    }
};
